module.exports = __webpack_public_path__ + "img/img23.4476e66d.png";